import { useEffect } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const MESSAGES = {
  escrow: "Pagamento Escrow confermato • Corsa bloccata",
  boost: "Spinta Priorità attiva ⚡ La corsa è in cima alla bacheca",
};

export const usePaymentReturn = (onDone) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sid = params.get("session_id") || (params.get("paypal_return") ? params.get("token") : null);
    if (params.get("payment") === "cancel") {
      if (params.get("token")) api.post(`/payments/cancel/${params.get("token")}`).catch(() => {});
      toast.info("Pagamento annullato");
      window.history.replaceState({}, "", window.location.pathname);
    }
    if (!sid) return;
    window.history.replaceState({}, "", window.location.pathname);
    const id = toast.loading("Conferma pagamento PayPal in corso…");
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          toast.success(MESSAGES[data.kind], { id });
          return onDone();
        }
        if (["expired", "failed", "refunded"].includes(data.payment_status)) {
          toast.error(data.payment_status === "refunded" ? "Corsa già presa da un collega: pagamento rimborsato" : "Pagamento non completato", { id });
          return onDone();
        }
      } catch {
        /* retry */
      }
      if (++tries < 15) setTimeout(poll, 2000);
      else toast.error("Pagamento non ancora confermato: controlla My Rides", { id });
    };
    poll();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
